import React, { useState } from "react";
import Users from "./users";
import Schools from "./schools";
import Districts from "./districts";
import { AddIcon } from "../../../assets/icons";
import { useNavigate } from "react-router";
import constant from "../../../utils/constant";
import { useLocation } from "react-router";

const Crm: React.FC = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";
  const getActiveTab = () => {
    const { crmType } = (location && location.state) || {};
    if (crmType) {
      return parseInt(crmType);
    }
    return constant.CRM_TYPE.USER;
  };
  const [activeTab, setActiveTab] = useState<number>(getActiveTab());
  const handleRedirect = () => {
    const redirectPath =
      activeTab == 1
        ? constant.crmAddUser
        : activeTab === 2
        ? constant.crmAddSchool
        : constant.crmAddDistrict;
    navigate(redirectPath);
  };

  return (
    <div>
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pr-80">
              <h3 className="text-lg font-light text-gray-900">Mini CRM</h3>
              <button
                type="button"
                className="hidden inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white bg-primary-color dark:text-white hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                onClick={() => handleRedirect()}
              >
                <AddIcon className="w-6"></AddIcon>
                Add{" "}
                {activeTab == 1
                  ? "Users"
                  : activeTab === 2
                  ? "Schools"
                  : "Districts"}
              </button>
            </div>
            <div className="pt-6 w-screen pr-80">
              <div className="flex items-center justify-between bg-gray-100 w-full">
                <div className="flex">
                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab(1);
                    }}
                  >
                    <h2
                      className={
                        activeTab === 1 ? activeTabClass : inActiveTabClass
                      }
                    >
                      Users
                    </h2>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab(2);
                    }}
                  >
                    <h2
                      className={
                        activeTab === 2 ? activeTabClass : inActiveTabClass
                      }
                    >
                      Schools
                    </h2>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab(3);
                    }}
                  >
                    <h2
                      className={
                        activeTab === 3 ? activeTabClass : inActiveTabClass
                      }
                    >
                      Districts
                    </h2>
                  </button>
                </div>
              </div>

              {activeTab === 1 && <Users />}
              {activeTab === 2 && <Schools />}
              {activeTab === 3 && <Districts />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crm;
